import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { verifyRegisters } from '../../actions/pos_actions';


import CashOutModal from '../../components/Sales/cashOutModal';

const cashOutModal = reduxForm({
  form: 'cashOutModal'
})(CashOutModal);

const selector = formValueSelector('cashOutModal');

function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, { verifyRegisters })(cashOutModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/cashOutModal.jsx